import styled, { css } from 'styled-components'

export interface StatusBadgeStyledProps {
  $variant?:
    | 'expired'
    | 'active'
    | 'pending'
    | 'success'
    | 'warning'
    | 'danger'
    | 'info'
  $size?: 'small' | 'medium'
}

const sizeStyles = {
  small: css`
    font-size: ${({ theme }) => theme.typography.fontSize.label};
    padding: 3px 6px;
  `,
  medium: css`
    font-size: ${({ theme }) => theme.typography.fontSize.micro};
    padding: 4px 8px;
  `,
}

const variantStyles = {
  expired: css`
    background: ${({ theme }) => theme.colors.background.tertiary};
    color: ${({ theme }) => theme.colors.text.tertiary};
  `,
  active: css`
    background: rgba(0, 179, 65, 0.1);
    color: ${({ theme }) => theme.colors.success};
  `,
  pending: css`
    background: rgba(255, 149, 0, 0.1);
    color: ${({ theme }) => theme.colors.warning};
  `,
  success: css`
    background: rgba(0, 179, 65, 0.1);
    color: ${({ theme }) => theme.colors.success};
  `,
  warning: css`
    background: rgba(255, 149, 0, 0.1);
    color: ${({ theme }) => theme.colors.warning};
  `,
  danger: css`
    background: rgba(255, 59, 48, 0.1);
    color: ${({ theme }) => theme.colors.danger};
  `,
  info: css`
    background: rgba(23, 162, 184, 0.1);
    color: #17a2b8;
  `,
}

export const Container = styled.span.withConfig({
  shouldForwardProp: (prop) => !prop.startsWith('$'),
})<StatusBadgeStyledProps>`
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  border-radius: ${({ theme }) => theme.borderRadius.small};
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-family: ${({ theme }) => theme.typography.fontFamily.sans};
  line-height: 1;
  display: inline-flex;
  align-items: center;
  white-space: nowrap;

  ${({ $size = 'medium' }) => sizeStyles[$size]}
  ${({ $variant = 'info' }) => variantStyles[$variant]}
`
